export const getIconWidth = (size) => {
    return `${size / 10}rem`;
};
export const getAriaHidden = (props) => {
    return !(props['aria-label'] || props['aria-labelledby']);
};
//# sourceMappingURL=utils.js.map